import { createContext } from "react";
import type { InlinePlaybackMediator } from "@/shared/lib/inlinePlaybackMediator";

export const InlinePlaybackContext: React.Context<InlinePlaybackMediator | null> =
  createContext<InlinePlaybackMediator | null>(null);
